import { _ } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

export const getConstraintType = (c: types.optimizer.ConstraintDraft): 'BOUNDS' | 'TARGET' => {
  if (_.isNil(c.target_lower) && _.isNil(c.target_upper)) return 'BOUNDS';
  return 'TARGET';
};
